/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestAutotaskConnectionRequest
 */
export interface TestAutotaskConnectionRequest {
    /**
     * Optional API user name to test (uses the stored one if not provided)
     */
    apiUserName?: string;
    /**
     * Optional new API secret to test (uses stored secret if not provided)
     */
    secret?: string;
    /**
     * Optional company id to resolve the company name for (uses the stored one if not provided)
     */
    companyId?: number;
}

/**
 * Check if a given object implements the TestAutotaskConnectionRequest interface.
 */
export function instanceOfTestAutotaskConnectionRequest(value: object): value is TestAutotaskConnectionRequest {
    return true;
}

export function TestAutotaskConnectionRequestFromJSON(json: any): TestAutotaskConnectionRequest {
    return TestAutotaskConnectionRequestFromJSONTyped(json, false);
}

export function TestAutotaskConnectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestAutotaskConnectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'apiUserName': json['apiUserName'] == null ? undefined : json['apiUserName'],
        'secret': json['secret'] == null ? undefined : json['secret'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
    };
}

export function TestAutotaskConnectionRequestToJSON(json: any): TestAutotaskConnectionRequest {
    return TestAutotaskConnectionRequestToJSONTyped(json, false);
}

export function TestAutotaskConnectionRequestToJSONTyped(value?: TestAutotaskConnectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiUserName': value['apiUserName'],
        'secret': value['secret'],
        'companyId': value['companyId'],
    };
}

